import styled from 'styled-components';

interface modalProps {
	show?: boolean;
}

const PopModal = styled.div<modalProps>`
    transition: ease-in all 0.4s;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 9998;
	background: rgba(0, 6, 19, 0.85);
	display: none;
	align-items: center;
	justify-content: center;
	animation: fadein 0.5s;
	@keyframes fadein {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
	${({ show }) =>
		show &&
		`display: flex;
	`}
`;

export default PopModal;
